module.exports = __webpack_public_path__ + "img/mickey42.b45b3ee9.jpg";